export const JSON_MIME_TYPE = 'json';
